import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import * as authActionCreators from "../actions/authentication";
import * as globalmessageActionCreators from "../actions/globalmessages";

import Main from "./Main";

function mapStateToProps(state) {
    return {
        authentication: state.authentication,
        globalmessages: state.globalmessages,
        userSettings: state.UserSettingsState,
        permissions: state.authentication?.user?.permissions,
        isLoggedIn: !!state.authentication.loginToken
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            ...authActionCreators,
            ...globalmessageActionCreators
        },
        dispatch
    );
}

const App = connect(mapStateToProps, mapDispatchToProps)(Main);

export default App;
